import { render, staticRenderFns } from "./ChartsextraPie.vue?vue&type=template&id=6a157d27&"
import script from "./ChartsextraPie.vue?vue&type=script&lang=js&"
export * from "./ChartsextraPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports